import { isMobileDevice, isTabletDevice } from '@va/dashboard/selectors/ui';
import classNames from 'classnames';
import { useMemo } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useSelector } from 'react-redux';

const LineChartCategoriesSkeletonPlaceholder = ({ totalItems }: { totalItems: number }) => {
  const isMobile = useSelector(isMobileDevice);
  const isTablet = useSelector(isTabletDevice);

  const skeletonCount = useMemo(() => {
    if (isMobile) return 2;
    if (isTablet) return 4;
    return totalItems;
  }, [isMobile, isTablet, totalItems]);

  const loaderHeight = useMemo(() => 'h-25.75 sm-initial:h-[6.675rem]', []);

  return (
    <div className={classNames('flex gap-4 scrollbar', loaderHeight)}>
      {Array.from(Array(skeletonCount).keys()).map((_, index) => {
        return (
          <div className='flex-1' key={`line-chart-skeleton-${index}`}>
            <Skeleton className={classNames('rounded-18', loaderHeight)} />
          </div>
        );
      })}
    </div>
  );
};

export default LineChartCategoriesSkeletonPlaceholder;
